import React from 'react'
import '../styles/layout/About.css'
import { Container, Image } from 'react-bootstrap';
import banner from '../assests/About-banner.png'

const AboutBanner = () => {
  return (
    <section className="page-hero aboutBanner">
      <Container>
        <div className="page-hero__band">
          <Image src={banner} alt="" />
          <span className="page-hero__band-tint" aria-hidden="true" />
          <span className="page-hero__band-wash" aria-hidden="true" />
          <span className="page-hero__band-edge" aria-hidden="true" />

          <div className="page-hero__copy">
            <h1>About Us</h1>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default AboutBanner
